module.exports = __webpack_public_path__ + "img/CPU-Coodesker.828fe45f.png";